import { CheckoutCustomerDetails } from '../checkout-customer/checkout-customer-details.interface';
import { CheckoutBasket } from '../checkout/checkout-basket.interface';
import { RegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.interface';
import { RegisteredItemProductDetails } from './registered-item-product-details.interface';

export interface RegisteredItem {
  appliances: RegistrationApplianceDetails[];
  earliestServiceAvailablityDate: string;
  effectiveDate: string;
  endDate: string;
  outOfGuarantee: boolean;
  Id: string;
  merchandiseBrand: string;
  merchandiseManufacturer: string;
  merchandiseType: string;
  numberOfAvailableSlots: string;
  paymentDescriptor: string;
  PersonEmail: string;
  personId: string;
  products: RegisteredItemProductDetails[];
  quoteNumber: string;
  serviceAvailabilityDaysSearched: string;
  standardPremium: number;
  status: string;
  tax: number;
  totalPrice: number;
  basket?: CheckoutBasket;
  customer?: CheckoutCustomerDetails;
}
